<template>
  <div class="app-shell">
    <HeaderComponent />
    <main class="app-content">
      <HomePage />
    </main>
    <FooterComponent />
  </div>
</template>

<script>
import HomePage from './components/Home.vue'
import HeaderComponent from './components/Header.vue'
import FooterComponent from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    HomePage,
    HeaderComponent,
    FooterComponent
  }
}
</script>

<style>
.app-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f3f7fc;
}

.app-content {
  flex: 1;
}
</style>
 
